import { ChangeEvent } from "react"

import { Form } from "react-bootstrap"

import PendingDrugTest from "../../../api/OrphanedResults/Models/PendingDrugTest"
import FormatDate from "../../../formatters/FormatDate"

interface PendingDrugTestProps {
  test: PendingDrugTest
  selected?: boolean
  highlighted?: boolean
  disabled?: boolean
  hideCheckbox?: boolean
  onSelect: (testId: string) => void
}

function PendingDrugTestRow({
  test,
  disabled = false,
  hideCheckbox = false,
  highlighted = false,
  selected = false,
  onSelect,
}: PendingDrugTestProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onSelect(e.target.value)
  }

  const isNotWithinCurrentProgramYear = () => {
    const currentProgramYear = new Date().getFullYear()
    const testProgramYear = test.ProgramStartDate?.getFullYear()
    // const dateOrderedYear = test.DateOrdered?.getFullYear()
    return !!testProgramYear && currentProgramYear !== testProgramYear
  }

  const isLess90Days = () => {
    const createdDate = test.DateOrdered
    if (createdDate !== undefined) {
      const timeDiff = new Date().getTime() - createdDate.getTime()
      const daysDiff = Math.round(timeDiff / (1000 * 3600 * 24))
      return daysDiff < 90
    }
    return false
  }

  const rowClassName = () => {
    const classes: string[] = []
    const notCurrentYear = isNotWithinCurrentProgramYear()
    if (notCurrentYear) classes.push("disabled")
    if (highlighted && isLess90Days() && !(notCurrentYear || disabled)) classes.push("bg-row-highlight")

    return classes.join(" ")
  }

  return (
    <tr
      className={rowClassName()}
      title={isNotWithinCurrentProgramYear() ? "The test not within the current program year" : ""}
    >
      <td className="align-middle">
        {!hideCheckbox && (
          <Form.Check
            type="checkbox"
            name="pending-test-detail"
            id={`ptd_${test.TestDetailID}`}
            className="abc-checkbox abc-checkbox-primary d-flex justify-content-center align-middle"
            value={test.TestDetailID}
            label=""
            disabled={disabled || isNotWithinCurrentProgramYear()}
            checked={selected}
            readOnly
            onChangeCapture={handleChange}
          />
        )}
      </td>
      <td title={test.Reason}>{test.ReasonDescription}</td>
      <td>{test.PoolID}</td>
      <td>{test.Regulated}</td>
      <td>{test.SampleType}</td>
      <td>{FormatDate(test.DateOrdered)}</td>
    </tr>
  )
}

export default PendingDrugTestRow
